<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">车牌号：</div>
        <el-input
          placeholder="请输入车牌号"
          size="medium"
          v-model="queryInfo.plNumber"
          @change="getPlNumber()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位人员设备卡片区域 -->
      <div class="leftBox">
        <!-- 单位人员设备树 -->

        <el-tree
          class="treeBox"
          :data="ArchInfo"
          :props="defaultTreesProps"
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          node-key="name"
          ref="navTree"
          @check-change="getCheckedDevicesNodes"
        >
          <!-- :render-content="renderContent"  -->
          <span slot-scope="{ node, data }">
            <div class="bigTree">
              <div class="leftTree">
                <div>
                  <!-- 单位图标 -->
                  <img
                    v-show="data.type == 1"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/dw.svg"
                  />
                  <!-- 人员图标 -->
                  <img
                    v-show="data.type == 2"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/ry.svg"
                  />
                  <!-- 执法仪不在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == false"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj.svg')
                        : require('../../../assets/img/tree/zngb.svg')
                    "
                  />
                  <!-- 执法仪在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == true"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy_online.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq_online.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm_online.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj_online.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj_online.svg')
                        : require('../../../assets/img/tree/zngb_online.svg')
                    "
                  />
                </div>

                <!-- 设备名称 -->
                <el-tooltip
                  v-show="data.type == 3"
                  class="item"
                  effect="dark"
                  :content="node.label"
                  placement="top"
                >
                  <div ref="nodeLabel">
                    <div v-if="node.label.length > 8">
                      {{
                        node.label.replace(
                          /(\d{3})\d*([0-9a-zA-Z]{3})/,
                          "$1***$2"
                        )
                      }}
                    </div>
                    <div v-else>
                      {{ node.label }}
                    </div>
                  </div>
                </el-tooltip>

                <!--  -->
                <!-- 单位和人员名称 -->
                <div ref="nodeLabel" v-show="data.type == 1 || data.type == 2">
                  {{ node.label }}
                </div>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
      <!-- 右边单位人员设备卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加车牌按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddPlNumberDialogVisible = true"
          >
            新增嫌疑车牌
          </el-button>
          <!-- 增加车牌按钮 -->
          <el-button
            icon="el-icon-share"
            type="primary"
            size="small"
            class="add-btn"
            @click="sendNumToDevices"
            v-if="sendNumBtn"
          >
            下发车牌
          </el-button>
          <!-- 车牌信息表格区域 -->
          <el-table
            :data="PlNumberList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
            @selection-change="handleSelectionChange"
            ref="PlNumberTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="plNumber" label="车牌号"> </el-table-column>
            <el-table-column prop="plCreatetime" label="创建时间">
            </el-table-column>
            <el-table-column prop="plChildrenShow" label="允许下级项目查看">
              <template v-slot="fenceSlot">
                <span>{{
                  fenceSlot.row.plChildrenShow == false ? "否" : "是"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="plRemake" label="备注"> </el-table-column>

            <el-table-column label="绑定设备">
              <template v-slot="slotPlId">
                <el-button
                  type="primary"
                  size="small"
                  @click="getPlIdDevice(slotPlId.row.plId)"
                  >查看下发设备</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="openUpdatePlNumber(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deletePlNumberByplId(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加车牌信息对话框 -->
    <el-dialog
      title="新增嫌疑车牌"
      :visible.sync="AddPlNumberDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddPlNumberDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addPlNumberFormRef"
        :rules="AddPlNumberRules"
        :model="PlNumberInfo"
        label-width="80px"
      >
        <el-form-item prop="plNumber" label="车牌号">
          <el-input
            placeholder="请输入车牌号"
            v-model="PlNumberInfo.plNumber"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="plRemake" label="备注">
          <el-input
            placeholder="请输入备注"
            v-model="PlNumberInfo.plRemake"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="允许下级项目查看">
          <el-radio-group
            v-model="PlNumberInfo.plChildrenShow"
            style="display: flex; height: 80px; align-items: center"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddPlNumberDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddPlNumber()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改车牌信息对话框 -->
    <el-dialog
      title="修改车牌信息"
      :visible.sync="UpdatePlNumberDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updatePlNumberFormRef"
        :rules="AddPlNumberRules"
        :model="UpdateInfo"
        label-width="80px"
      >
        <el-form-item prop="plNumber" label="车牌号">
          <el-input
            placeholder="请输入车牌号"
            v-model="UpdateInfo.plNumber"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="plRemake" label="备注">
          <el-input
            placeholder="请输入备注"
            v-model="UpdateInfo.plRemake"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="允许下级项目查看">
          <el-radio-group
            v-model="UpdateInfo.plChildrenShow"
            style="display: flex; height: 80px; align-items: center"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdatePlNumberDialog = false">取 消</el-button>
        <el-button type="primary" @click="Update()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看下发车牌信息对话框 -->
    <el-dialog
      title="车牌已下发设备"
      :visible.sync="sendDevicesDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearsendDevicesDialogVisible()"
    >
      <el-table
        :data="sendDevicesList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
        :default-sort="{ prop: 'devCreatetime', order: 'descending' }"
      >
        <el-table-column prop="devEmpName" label="使用人员"> </el-table-column>
        <el-table-column prop="devNo" label="设备编号"> </el-table-column>
        <el-table-column prop="devCreatetime" sortable label="下发时间">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="UnissueSlot">
            <el-button
              type="warning"
              size="small"
              @click="Unissue(UnissueSlot.row.devId)"
              >解除下发</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    // 车牌正确验证
    var carPhoneValid = (rule, value, callback) => {
      const plateNumber =
        /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DABCEFGHJK]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DABCEFGHJK]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/;
      if (plateNumber.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的车牌号"));
      }
    };
    return {
      // 车牌列表信息
      PlNumberList: [],
      // 车牌列表查询信息
      queryInfo: {
        // 车牌号
        plNumber: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //  单位总数量
      total: 0,
      // 单位人员设备树信息
      ArchInfo: [],
      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name",
      },
      // 控制增加单位对话框的显示和隐藏
      AddPlNumberDialogVisible: false,
      // 控制发送车牌按钮显示与隐藏
      sendNumBtn: false,
      // 下发车牌参数
      sendNumToDevicesInfo: {
        devIds: [], //设备id
        plIds: [], //车牌id
      },
      // 车牌实体
      PlNumberInfo: {
        // 车牌号
        plNumber: "",
        // 备注
        plRemake: "",
        // 是否允许下级查看
        plChildrenShow: false,
      },
      // 查看下发设备对话框
      sendDevicesDialog: false,
      // 车牌下发设备
      sendDevicesList: [],
      //解除车牌下发设备的车牌ID
      unissuePlId: "",
      // 控制修改对话框的显示和隐藏
      UpdatePlNumberDialog: false,
      // 修改车牌实体
      UpdateInfo: {
        // 车牌号
        plNumber: "",
        // 备注
        plRemake: "",
        // 是否允许下级查看
        plChildrenShow: false,
      },
      //增加车牌规则校验
      AddPlNumberRules: {
        plNumber: [
          {
            required: true,
            trigger: "blur",
            validator: carPhoneValid,
          },
        ],
      },
    };
  },
  created() {
    // 获取车牌列表信息
    this.getPlNumber();
    // 获取单位人员设备树
    this.getDepPersonDevTree();
  },
  mounted() {},
  methods: {
    // 查询车牌列表信息
    async getPlNumber() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/platelibrary/search`,
        {
          params: this.queryInfo,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.PlNumberList = res.data.rows;
      // 车牌总数量
      this.total = res.data.total;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getPlNumber();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getPlNumber();
    },

    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;
    },

    //获取tree选中的设备devIds
    getCheckedDevicesNodes() {
      var devices = this.$refs.navTree.getCheckedNodes();
      var devIds = [];
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.type == 3) {
          devIds.push(element.id);
        }
      }
      this.sendNumToDevicesInfo.devIds = devIds;
    },
    // 获取table选中的车牌信息
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.sendNumBtn = true;
      } else {
        this.sendNumBtn = false;
      }
      var plIds = [];
      for (let i = 0; i < val.length; i++) {
        plIds.push(val[i].plId);
      }
      this.sendNumToDevicesInfo.plIds = plIds;
    },
    // 嫌疑车牌下发
    async sendNumToDevices() {
      if (this.sendNumToDevicesInfo.devIds.length == 0) {
        return this.$message.warning("请选择要下发的设备!");
      }
      const { data: res } = await this.$axios.post(
        `${this.$api}/platelibrary/send`,
        this.sendNumToDevicesInfo
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 清空树的选中
      this.$refs.navTree.setCheckedNodes([]);
      // 清空表格选中国
      this.$refs.PlNumberTable.clearSelection();
      this.$message.success("车牌下发成功");
    },

    // 根据车牌查看对应下发的设备
    async getPlIdDevice(plId) {
      this.unissuePlId = plId;
      const { data: res } = await this.$axios.get(
        `${this.$api}/platelibrary/getPlIdDevice`,
        {
          params: { plId: plId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesDialog = true;
      if (res.data.rows !== null && res.data.rows !== "") {
        this.sendDevicesList = res.data.rows;
      }
    },

    // 解除设备下发车牌
    async Unissue(devId) {
      const confirmVal = await this.$confirm(
        "此操作将会解除此设备的车牌下发, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/platelibrary/unissue`,
        {
          params: { devId: devId, plId: this.unissuePlId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesList = [];
      this.getPlIdDevice(this.unissuePlId);
    },
    // 关闭车牌查看对应下发的设备对话框
    clearsendDevicesDialogVisible() {
      this.sendDevicesList = [];
    },
    // 增加车牌
    AddPlNumber() {
      this.$refs.addPlNumberFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/platelibrary/add`,
          this.PlNumberInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("新增车牌成功");
        this.AddPlNumberDialogVisible = false;
        this.getPlNumber();
      });
    },
    //关闭增加车牌信息
    clearAddPlNumberDialogVisible() {
      this.$refs.addPlNumberFormRef.resetFields();
    },
    //打开修改车牌信息对话框
    openUpdatePlNumber(vule) {
      this.UpdatePlNumberDialog = true;
      // 车牌ID
      this.UpdateInfo.plId = vule.plId;
      // 车牌号
      this.UpdateInfo.plNumber = vule.plNumber;
      // 备注
      this.UpdateInfo.plRemake = vule.plRemake;
      // 是否允许下级单位查看
      this.UpdateInfo.plChildrenShow = vule.plChildrenShow;
    },

    // 修改车牌信息
    async Update() {
      this.$refs.updatePlNumberFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/platelibrary/modify/${this.UpdateInfo.plId}`,
          {
            // 车牌号
            plNumber: this.UpdateInfo.plNumber,
            // 备注
            plRemake: this.UpdateInfo.plRemake,
            // 是否允许下级单位查看
            plChildrenShow: this.UpdateInfo.plChildrenShow,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("修改车牌信息成功");
        this.getPlNumber();
        this.UpdatePlNumberDialog = false;
      });
    },

    //关闭修改车牌信息对话框
    clearUpdateDialogVisible() {
      this.$refs.updatePlNumberFormRef.resetFields();
    },
    // 删除车牌号
    async deletePlNumberByplId(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该车牌号, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/platelibrary/delete/` + value.plId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("车牌删除成功");
      this.getPlNumber();
    },
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 260px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  display: flex;
}

.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}


.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  // width: 1%;
  vertical-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/IntelligentAI/numberplateDatabase.vue